import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage'
import imgStage from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Stagew.jpg'
import SectionHeader from '../../../Components/SectionHeader/SectionHeader'
import ImageText from '../../../Components/ImageText/ImageText'
import ServiceCarousel from '../../../Components/ServiceCarousel/ServiceCarousel'
import imgCheque from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Cheque2025.png'
import imgRehabilitation from '../../../assets/ResponsibilityAndSocialCommitments/Donation/RehabilitationVeterans2025.png'
import imgSocialCenter from '../../../assets/ResponsibilityAndSocialCommitments/Donation/SocialCenterNovogradkovka2025.png'
import imgSolidatory from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Solidatory.jpg'
import imgEngineers from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Engineers.jpg'
import imgBORDA from '../../../assets/ResponsibilityAndSocialCommitments/Donation/BORDA.jpg'
import imgViva from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Viva.jpg'

const DonationInsteadGifts = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const data1 = {
        image: imgCheque,
        title: 'Cheque handed over to the Solidarity Foundation Ukraine',
        description: '"As a company, it is important to us to take responsibility and help people in particular need. Our support is primarily directed at those who are suffering most from the consequences of the war. We hope for a peaceful solution soon so that we can implement specific aid projects on the ground," says Alina Armerding, co-owner of HANSA-FLEX and chair of the foundation. Your help is also welcome – support the foundation directly:',
        buttonName: "More Information",
        buttonLink: 'https://stiftung-solidaritaet-ukraine.de/'
    }

    const data2 = {
        image: imgRehabilitation,
        title: 'Psychological rehabilitation for veterans',
        description: 'In Richta, located in the Carpathian Mountains, veterans and their families receive comprehensive psychological support to help them process their war experiences. The program strengthens stability, resources, and family ties. The €20,000 donation will benefit more than 80 people receiving this treatment. The goal is to help them successfully return to everyday life.',
    }

    const data3 = {
        image: imgSocialCenter,
        title: "Social center in Novogradkovka",
        description: "In Novogradkovka, a dilapidated church building is being converted into a social center that offers childcare, hot meals, assistance for seniors, and winter shelter. The project responds to poverty, lack of care, and high levels of need in the region. 20,000 euros are being invested in this project to provide long-term support and better living conditions for the village community.",
    }

    const ServiceCarouselData = [
        {
            title: "Solidarity Ukraine Foundation",
            description: "In 2022, we established the Solidarity Ukraine Foundation together with BUHLMANN Rohr-Fittings-Stahlhandel GmbH + Co. Its aim is to support the reconstruction of critical infrastructure, such as healthcare and educational facilities in Ukraine. We donated a total of EUR 100,000 in 2022-2023.",
            imageSrc: imgSolidatory
        },
        {
            title: "Engineers without borders",
            description: "Together with local partners, Engineers without borders is committed to support the development of basic services such as electricity, water and sanitation. In the years 2017-2021, a total of EUR 135,000 was donated to support projects in Guinea, Tanzania and Uganda.",
            imageSrc: imgEngineers
        },
        {
            title: "BORDA",
            description: "To provide access to sanitary facilities, BORDA e. V. works with partners around the world to support the construction of water, wastewater and sanitary facilities. In 2017-2021, we donated a total of EUR 80,000 to support projects in India, Bangladesh and Jordan.",
            imageSrc: imgBORDA
        },
        {
            title: "Viva con Agua de Sankt Pauli",
            description: "Viva con Agua focuses on water, sanitation and hygiene projects. The organisation works with local partners around the world to build drinking water and sanitation facilities and runs workshops. In 2017-2021, we supported projects in Nepal, Uganda and Mozambique with a total of EUR 60,000.",
            imageSrc: imgViva
        }
    ];

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"DONATIONS INSTEAD OF GIFTS"}
                paragraph={"For several years now, HANSA-FLEX has decided to commit our annual budget for corporate gifts to support charitable causes. Such as in the last years, this year’s donation will go to the Solidarity Foundation Ukraine."} />

            <SectionHeader title={"SUPPORTED PROJECTS 2025"} />
            <ImageText data={data1} left={true} />
            <ImageText data={data2} left={false} />
            <ImageText data={data3} left={true} />

            <SectionHeader title={"PROJECTS SUPPORTED IN RECENT YEARS"} />
            <ServiceCarousel images={ServiceCarouselData} autoPlayInterval={5000} />
        </div>
    )
}

export default DonationInsteadGifts
